module.exports = __webpack_public_path__ + "static/img_4717-a156792c528ceba6d2eb69d390730d19.webp";